import React from 'react'
import './styles.scss'

export default ({ cost }) => (
  <div className='cost-per-mb center-child indicator'>
    <span>Cost/MB</span>
    <span>$ {cost}</span>
  </div>
)
